// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3t6p9","content":"styles_content__2ZQAx","selectAll":"styles_selectAll__2_4NW"};